// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__32OEA","title":"Info_title__2Fgej","selects":"Info_selects__KRjtk","requiredAsterisk":"Info_requiredAsterisk__38pG8"};